import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  modelos: [],
  isLoading: false,
};

const modeloVehiculoSelectorSlice = createSlice({
  name: "business/modeloVehiculo",
  initialState,
  reducers: {
    fetchModelosVehiculosInited: {
      prepare: (props) => ({ payload: { props } }),
      reducer: (state) => {
        state.modelos = [];
        state.isLoading = true;
      },
    },
    fetchModelosVehiculosCompleted: {
      prepare: (response) => ({ payload: { response } }),
      reducer: (state, action) => {
        state.modelos = action.payload.response.items.map((x) => ({
          value: x.codia,
          label: x.version,
        }));
        state.isLoading = false;
      },
    },
    fetchModelosVehiculosFailed: {
      prepare: (error) => ({ payload: { error } }),
      reducer: (state) => {
        state.modelos = [];
        state.isLoading = false;
      },
    },
  },
});

const {
  fetchModelosVehiculosInited,
  fetchModelosVehiculosCompleted,
  fetchModelosVehiculosFailed,
} = modeloVehiculoSelectorSlice.actions;

const fetchModelosVehiculos = (marca, anio, preciosModifier) => {
  return async (dispatch, getState, services) => {
    try {
      dispatch(fetchModelosVehiculosInited({ marca, anio, preciosModifier }));
      const response = await services.api.getVehiclesVersiones(
        marca,
        anio,
        preciosModifier,
      );
      dispatch(fetchModelosVehiculosCompleted(response));
    } catch (error) {
      console.error(error);
      dispatch(fetchModelosVehiculosFailed(error));
    }
  };
};

export default modeloVehiculoSelectorSlice.reducer;
export {
  fetchModelosVehiculos,
  fetchModelosVehiculosInited,
  fetchModelosVehiculosCompleted,
  fetchModelosVehiculosFailed,
};
